// Packages

// Components
import { EventsItems } from "./EventsItems";

// Logic

// Context

// Services

// Styles

// Assets

export const Events = () => {
	return (
		<div className='unit-page-subpage unit-page-subpage-events'>
			<EventsItems />
		</div>
	);
};
